import axios from 'src/admin-axios';
import Constants from 'src/constants';

export const organizations = {
    namespaced: true,
    state: {
        organizationList: [],
        organizationDetails: {},
        OrganizationModuleDetails: {},
        organizationSubscriptionDetails: {},
        appModules: [],
        moduleTypes: [],
        organizationLinkedPartners: [],
    },
    getters: {
        getOrganizationList (state) {
            return state.organizationList;
        },
        getOrganizationDetails (state) {
            return state.organizationDetails;
        },
        getOrganizationModuleDetails (state) {
            return state.OrganizationModuleDetails;
        },
        getOrganizationSubscriptionDetails (state) {
            return state.organizationSubscriptionDetails;
        },
        getAppModules (state) {
            return state.appModules;
        },
        getModuleTypes (state) {
            return state.moduleTypes;
        },
        getOrganizationLinkedPartners (state) {
            return state.organizationLinkedPartners;
        },
    },
    mutations: {
        setOrganizationList (state, data) {
            state.organizationList = data;
        },
        setOrganizationDetails (state, data) {
            state.organizationDetails = data;
        },
        setOrganizationModuleDetails (state, data) {
            state.OrganizationModuleDetails = data;
        },
        setOrganizationSubscriptionDetails (state, data) {
            state.organizationSubscriptionDetails = data;
        },
        setAppModules (state, data) {
            state.appModules = data;
        },
        setModuleTypes (state, types) {
            state.moduleTypes = types;
        },
        setOrganizationLinkedPartners (state, partners) {
            state.organizationLinkedPartners = partners;
        },
    },
    actions: {
        async fetchOrganizationList ({ dispatch, commit }) {
            const url = '/organizations';
            try {
                const details = await axios.get(url);
                commit('setOrganizationList', details.data);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in getting organization list.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
            }
        },
        async createOrganization ({ dispatch }, payload) {
            const url = '/organizations';
            try {
                 await axios.post(url, payload);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in creating your organization.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
            }
        },
        async fetchOrganizationDetails ({ dispatch, commit }, payload) {
            const url = `/organizations/${payload.organizationId}`;
            try {
                const details = await axios.get(url);
                commit('setOrganizationDetails', details.data);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in getting your organization details.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
                throw exception;
            }
        },
        async fetchOrganizationModuleDetails ({ dispatch, commit }, payload) {
            const url = `/organizations/${payload.organizationlId}/app-modules/${payload.appModuleName}/modules`;
            try {
                const details = await axios.get(url);
                commit('setOrganizationModuleDetails', details.data);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in getting your organization module list.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
            }
        },
        async  updateOrganizationModuleSettings ({ dispatch }, payload) {
            const url = `organizations/${payload.organizationId}/app-modules/${payload.appModuleName}/modules/${payload.moduleId}`;
            try {
                await axios.put(url, payload.settings);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in updating organization module settings.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
                throw exception;
            }
        },
        async  createOrganizationModule ({ dispatch }, payload) {
            const url = `organizations/${payload.organizationId}/app-modules/${payload.appModuleName}/modules`;
            try {
                await axios.post(url, payload.settings);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in creating organization module settings.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
                throw exception;
            }
        },
        async  updateOrganization ({ dispatch }, payload) {
            const url = `organizations/${payload.organizationId}`;
            try {
                await axios.put(url, payload.editOrganizationDetails);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in updating organization details.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
                throw exception;
            }
        },
        async fetchOrganizationSubscriptionDetails ({ dispatch, commit }, payload) {
            const url = `organizations/${payload.organizationId}/app-modules/${payload.appModuleName}/subscription`;
            try {
                const details = await axios.get(url);
                commit('setOrganizationSubscriptionDetails', details.data);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in getting the subscription details of selected organization.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
                throw exception;
            }
        },
        async  createAppModule ({ dispatch }, payload) {
            const url = '/app-modules';
            try {
                await axios.post(url, payload);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in creating a new App Module.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
                throw exception;
            }
        },
        async fetchAppModules ({ dispatch, commit }) {
            const url = '/app-modules/all';
            try {
                const details = await axios.get(url);
                commit('setAppModules', details.data);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in getting the App Modules list.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
                throw exception;
            }
        },
        async assignOrgAppModule ({ dispatch }, payload) {
            const url = `/organizations/${payload.organizationId}/app-modules`;
            try {
                 await axios.post(url, payload.appModule);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in assigning this app module against this organization.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
                throw exception;
            }
        },
        async fetchModuleTypes ({ dispatch, commit }, payload) {
            const url = `app-modules/${payload.appModuleName}/modules`;
            try {
                const types = await axios.get(url);
                commit('setModuleTypes', types.data);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in getting the Module types list.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
                throw exception;
            }
        },
        async fetchOrganizationLinkedPartners ({ dispatch, commit }, payload) {
            const url = `organizations/${payload.organizationId}/partners`;
            try {
                const partners = await axios.get(url);
                commit('setOrganizationLinkedPartners', partners.data);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in getting the organization partners list.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
                throw exception;
            }
        },
        async linkOrganizationPartner ({ dispatch }, payload) {
            const url = `/organizations/${payload.organizationId}/partners/${payload.partnerId}/assign`;
            try {
                 await axios.post(url);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in assigning this partner against this organization.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
                throw exception;
            }
        },
    },
};
